var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.18 0.000207237C43.8732 0.000224471 44.9315 1.82242 44.0853 3.28049L33.9055 20.8197C33.0589 22.2783 30.9415 22.2783 30.0949 20.8197L19.9148 3.28031C19.0685 1.82222 20.1268 -1.72342e-05 21.82 1.22268e-10L42.18 0.000207237Z",
    fill: "#6826F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7883 6.22815C13.9417 4.76958 11.8244 4.76956 10.9778 6.22812L0.797787 23.7668C-0.0485281 25.2249 1.00983 27.0471 2.703 27.0471L23.0629 27.0473C24.7561 27.0474 25.8145 25.2251 24.9682 23.767L14.7883 6.22815Z",
    fill: "#6826F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.297 27.0469C62.9902 27.0469 64.0485 25.2247 63.2022 23.7666L53.0223 6.22762C52.1757 4.76906 50.0585 4.76903 49.2118 6.22757L39.0313 23.7666C38.1849 25.2247 39.2433 27.047 40.9365 27.047L61.297 27.0469Z",
    fill: "#6826F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7883 53.7718C13.9417 55.2304 11.8244 55.2304 10.9778 53.7719L0.797787 36.2332C-0.0485281 34.7751 1.00983 32.9529 2.703 32.9529L23.0629 32.9527C24.7561 32.9526 25.8145 34.7749 24.9682 36.233L14.7883 53.7718Z",
    fill: "#6826F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.18 59.9998C43.8732 59.9998 44.9315 58.1776 44.0853 56.7195L33.9055 39.1803C33.0589 37.7217 30.9415 37.7217 30.0949 39.1803L19.9148 56.7197C19.0685 58.1778 20.1268 60 21.82 60L42.18 59.9998Z",
    fill: "#6826F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.297 32.9531C62.9902 32.9531 64.0485 34.7753 63.2022 36.2334L53.0223 53.7724C52.1757 55.2309 50.0585 55.231 49.2118 53.7724L39.0313 36.2334C38.1849 34.7753 39.2433 32.953 40.9365 32.953L61.297 32.9531Z",
    fill: "#6826F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.40a36e876b9669f8538b487ced22f971.svg";
export { ForwardRef as ReactComponent };